__turbopack_context__.v({
  "container_noAdsLayout": "_5oLaTW_container_noAdsLayout",
  "padding0": "_5oLaTW_padding0",
  "padding30": "_5oLaTW_padding30",
  "padding52": "_5oLaTW_padding52",
});
